import {httpErrorCheck} from '../utils/errors';
import {Routing} from '../routing';
import {mergeHeaders} from './merge-headers';
import {defaultOptions} from './default-options';

export function post(url: string, body: any, options: RequestInit = {}) {
    const postDefaultHeaders = mergeHeaders({'Content-Type': 'application/json'});
    // @ts-ignore
    const headers = mergeHeaders(options.headers, postDefaultHeaders);
    const contentType = headers.get('Content-Type');

    return fetch(url, {
        ...defaultOptions,
        ...options,
        method: 'POST',
        headers,
        body:
            contentType && contentType.includes('json')
                ? JSON.stringify(body)
                : Routing.param(body),
    }).then(httpErrorCheck);
}
